import { defineMessages } from 'react-intl'

export default defineMessages({
  headline: {
    id: 'components.InitialProcess.headline',
    defaultMessage: 'Get {language} voices you can trust',
  },
  headlineDefault: {
    id: 'components.InitialProcess.headlineDefault',
    defaultMessage: 'Get voice overs you can trust',
  },
  description: {
    id: 'components.InitialProcess.description',
    defaultMessage: 'Only human and professional voice artists. Hear it in your script before you commit with a free demo. No hidden costs. No surprises.',
  },
  processTitle: {
    id: 'components.InitialProcess.processTitle',
    defaultMessage: "Here's how to get started",
  },
  step1Title: {
    id: 'components.InitialProcess.step1Title',
    defaultMessage: 'Specify your needs',
  },
  step2Title: {
    id: 'components.InitialProcess.step2Title',
    defaultMessage: 'Play demos and select a voice',
  },
  step3Title: {
    id: 'components.InitialProcess.step3Title',
    defaultMessage: 'Request quote',
  },
})
